import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Table } from 'reactstrap';
import { Translate, TextFormat, getSortState, JhiPagination, JhiItemCount } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IActivity } from 'app/shared/model/activity.model';
import { getEntities } from './activity.reducer';

export const Activity = () => {
  const dispatch = useAppDispatch();

  const location = useLocation();
  const navigate = useNavigate();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(location, ITEMS_PER_PAGE, 'id'), location.search)
  );

  const activityList = useAppSelector(state => state.activity.entities);
  const loading = useAppSelector(state => state.activity.loading);
  const totalItems = useAppSelector(state => state.activity.totalItems);

  const getAllEntities = () => {
    dispatch(
      getEntities({
        page: paginationState.activePage - 1,
        size: paginationState.itemsPerPage,
        sort: `${paginationState.sort},${paginationState.order}`,
      })
    );
  };

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (location.search !== endURL) {
      navigate(`${location.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [location.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  return (
    <div>
      <h2 id="activity-heading" data-cy="ActivityHeading">
        <Translate contentKey="activitiesApp.activity.home.title">Activities</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="activitiesApp.activity.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link to="/activity/new" className="btn btn-primary jh-create-entity" id="jh-create-entity" data-cy="entityCreateButton">
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="activitiesApp.activity.home.createLabel">Create new Activity</Translate>
          </Link>
        </div>
      </h2>
      <div className="table-responsive">
        {activityList && activityList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="activitiesApp.activity.id">ID</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('name')}>
                  <Translate contentKey="activitiesApp.activity.name">Name</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('summaryDescription')}>
                  <Translate contentKey="activitiesApp.activity.summaryDescription">Summary Description</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('detailedDescription')}>
                  <Translate contentKey="activitiesApp.activity.detailedDescription">Detailed Description</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                  <th className="hand" onClick={sort('experienceHeader')}>
                  <Translate contentKey="activitiesApp.activity.experienceHeader">Experience Header</Translate>{' '}
                  <FontAwesomeIcon icon="sort"  />
                    </th>
                  <th className="hand" onClick={sort('experienceShort')}>
                  <Translate contentKey="activitiesApp.activity.experienceShort">Experience Short</Translate>{' '}
                  <FontAwesomeIcon icon="sort"  />
                    </th>
                <th className="hand" onClick={sort('durationNote')}>
                  <Translate contentKey="activitiesApp.activity.durationNote">Duration Note</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('startDate')}>
                  <Translate contentKey="activitiesApp.activity.startDate">Start Date</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('endDate')}>
                  <Translate contentKey="activitiesApp.activity.endDate">End Date</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('childFriendly')}>
                  <Translate contentKey="activitiesApp.activity.childFriendly">Child Friendly</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('childFriendlyNote')}>
                  <Translate contentKey="activitiesApp.activity.childFriendlyNote">Child Friendly Note</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('activityType')}>
                  <Translate contentKey="activitiesApp.activity.activityType">Activity Type</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th className="hand" onClick={sort('createdDate')}>
                  <Translate contentKey="activitiesApp.activity.createdDate">Created Date</Translate>{' '}
                </th>
                <th className="hand" onClick={sort('modifiedDate')}>
                  <Translate contentKey="activitiesApp.activity.modifiedDate">Modified Date</Translate>{' '}
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="activitiesApp.activity.active">Active</Translate>{' '}
                </th>
                <th className="hand" onClick={sort('userName')}>
                  <Translate contentKey="activitiesApp.activity.userName">User Name</Translate>{' '}
                </th>
                <th className="hand" onClick={sort('whatsIncluded')}>
                  <Translate contentKey="activitiesApp.activity.whatsIncluded">Whats Included</Translate>{' '}
                </th>
                <th className="hand" onClick={sort('whatToBring')}>
                  <Translate contentKey="activitiesApp.activity.whatToBring">What To Bring</Translate>{' '}
                </th>
                <th className="hand" onClick={sort('departs')}>
                  <Translate contentKey="activitiesApp.activity.departs">Departs</Translate>{' '}
                </th>
                <th className="hand" onClick={sort('restrictions')}>
                  <Translate contentKey="activitiesApp.activity.restrictions">Restrictions</Translate>{' '}
                </th>
                <th>
                  <Translate contentKey="activitiesApp.activity.location">Location</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="activitiesApp.activity.user">User</Translate> <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {activityList.map((activity, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/activity/${activity.id}`} color="link" size="sm">
                      {activity.id}
                    </Button>
                  </td>
                  <td>{activity.name}</td>
                  <td>{activity.summaryDescription}</td>
                  <td>{activity.detailedDescription}</td>
                  <td>{activity.experienceHeader}</td>
                  <td>{activity.experienceShort}</td>
                  <td>{activity.durationNote}</td>
                  <td>{activity.startDate ? <TextFormat type="date" value={activity.startDate} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>{activity.endDate ? <TextFormat type="date" value={activity.endDate} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>{activity.childFriendly ? 'true' : 'false'}</td>
                  <td>{activity.childFriendlyNote}</td>
                  <td>
                    <Translate contentKey={`activitiesApp.ActivityType.${activity.activityType}`} />
                  </td>
                  <td>{activity.createdDate ? <TextFormat type="date" value={activity.createdDate} format={APP_DATE_FORMAT} /> : null}</td>
                  <td>
                    {activity.modifiedDate ? <TextFormat type="date" value={activity.modifiedDate} format={APP_DATE_FORMAT} /> : null}
                  </td>
                  <td>{activity.active ? 'true' : 'false'}</td>
                  <td>{activity.userName}</td>
                  <td>{activity.location ? <Link to={`/location/${activity.location.id}`}>{activity.location.cityName}</Link> : ''}</td>
                  <td>{activity.user ? activity.user.login : ''}</td>
                  <td>{activity.whatsIncluded}</td>
                  <td>{activity.whatToBring}</td>
                  <td>{activity.departs}</td>
                  <td>{activity.restrictions}</td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`/activity/${activity.id}`} color="info" size="sm" data-cy="entityDetailsButton">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/activity/${activity.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/activity/${activity.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="activitiesApp.activity.home.notFound">No Activities found</Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={activityList && activityList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Activity;
